import React, { useState, useCallback } from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps, pickAriaProps, pickDataProps, } from '../../interfaces/commonProps';
import { togglePropTypes } from './Toggle.types';
import { StyledContainer, StyledLabel, StyledToggleButton, StyledOnIndicator, StyledOffIndicator, StyledToggleContainer, StyledToggleSwitch, } from './Toggle.styles';
export const Toggle = React.forwardRef(({ id, name, on, defaultOn = false, disabled = false, children, inputId, inputRef, onChange: handleChange = () => { }, 'aria-labelledby': labelledBy, ...restProps }, ref) => {
    const [internalState, setInternalState] = useState(defaultOn);
    const state = on !== null && on !== void 0 ? on : internalState;
    const handleClick = useCallback((event) => {
        handleChange(!state, event);
        if (on === undefined) {
            setInternalState(!internalState);
        }
    }, [handleChange, internalState, on, state]);
    return (React.createElement(StyledContainer, { id: id, ref: ref, outerSpacing: useSpacing(restProps), ...pickComponentCommonProps(restProps), ...pickAriaProps(restProps), ...pickDataProps(restProps) },
        React.createElement(StyledToggleContainer, null,
            React.createElement(StyledToggleButton, { id: inputId, ref: inputRef, name: name, type: "button", role: "switch", disabled: disabled, "aria-labelledby": labelledBy, "aria-checked": state, onClick: handleClick }),
            React.createElement(StyledOnIndicator, null),
            React.createElement(StyledOffIndicator, null),
            React.createElement(StyledToggleSwitch, null)),
        children && (React.createElement(StyledLabel, { disabled: disabled, htmlFor: inputId }, children))));
});
Toggle.displayName = 'Toggle';
Toggle.propTypes = togglePropTypes;
//# sourceMappingURL=Toggle.js.map